import styled from 'styled-components';

export const Card = styled.button<{ $picture?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  padding: 0;
  border-radius: ${({ $picture }) => ($picture ? '4% / 4.25%' : '14px')};
  overflow: hidden;
  cursor: pointer;
  font: inherit;
  border: ${({ $picture, theme: { colors } }) => ($picture ? 'none' : `1px solid ${colors.outlineVariant}`)};
  background: ${({ $picture, theme: { colors } }) => ($picture ? 'transparent' : colors.surfaceContainer)};
  color: ${({ theme: { colors } }) => colors.onSurface};
  transition: border-color 120ms ease, transform 120ms ease, box-shadow 120ms ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme: { colors } }) => colors.primary};
    transform: translateY(-1px);
    box-shadow: ${({ theme: { elevation } }) => elevation?.level2 ?? 'none'};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: { colors } }) => colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: progress;
    opacity: 0.6;
  }
`;

export const CardCover = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 1180 / 1104;
  object-fit: cover;
`;

export const CardBody = styled.span`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding: 18px 22px 22px;
`;

export const CardIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  margin-bottom: 6px;
  background: ${({ theme: { colors } }) => colors.primaryContainer};
  color: ${({ theme: { colors } }) => colors.onPrimaryContainer};
`;

export const CardTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const CardTagline = styled.span`
  font-size: 13px;
  line-height: 1.45;
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;

export const CardMeta = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;

export const FormatGroup = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const FormatChip = styled.span`
  display: inline-block;
  padding: 2px 7px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  background: ${({ theme: { colors } }) => colors.surfaceContainerHigh};
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;

export const CoverCaption = styled.span`
  position: absolute;
  inset: auto 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 8% 9%;
`;

export const CoverTitle = styled.span`
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
  overflow-wrap: anywhere;
`;

export const CoverTagline = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 13px;
  line-height: 1.45;
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;

export const RunsOnBadge = styled.span<{ $overlay: boolean }>`
  ${({ $overlay }) => ($overlay ? 'position: absolute; top: 8px; left: 8px;' : '')}
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ theme: { colors } }) => colors.surfaceContainerHighest};
  color: ${({ theme: { colors } }) => colors.onSurface};
`;
